import React, { PureComponent } from 'react';
import { PlusOutlined } from '@ant-design/icons';
import { Button, Tooltip, Typography } from 'antd';
import PageHeaderWrapper from '@/components/PageHeaderWrapper';
import CloudAccountTable from '@/components/CloudAccounts/CloudAccountTable';
import { connect } from 'dva';
import { userCan } from '@/utils/authority';
import { PATH_DASHBOARD } from '@/utils/routes/path';

let { Title } = Typography;
@connect(({ organisation, loading, cloudAccount }) => ({
  organisation: organisation.current,
  loading: loading.models.cloudAccount,
  cloudAccount,
  packageExpiry: organisation.packageExpiry,
}))
class CloudAccountsList extends PureComponent {
  deleteAccount(deleteParticularAccount) {
    const { dispatch, organisation } = this.props;
    dispatch({
      type: 'cloudAccount/update',
      payload: {
        params: {
          type: 'delete',
          id: deleteParticularAccount.userId,
          orgId: organisation.id,
        },
      },
    });
  }

  saveDocs(saveDocument) {
    const { dispatch, organisation } = this.props;
    dispatch({
      type: 'cloudAccount/update',
      payload: {
        params: {
          type: 'interval',
          orgId: organisation.id,
          id: saveDocument.cloudAccountId,
        },
        data: saveDocument,
      },
    });
  }

  render() {
    const { packageExpiry } = this.props;
    return (
      <PageHeaderWrapper
        title="Cloud Accounts"
        content={
          <>
            <Title level={4}>Cloud Accounts</Title>
            <Tooltip
              title={
                userCan('create-cloud-account')
                  ? 'Add cloud account'
                  : "You don't have permission to add cloud account."
              }
            >
              <Button
                disabled={packageExpiry === 'expired' || !userCan('create-cloud-account')}
                icon={<PlusOutlined />}
                onClick={() => {
                  this.props.history.push(PATH_DASHBOARD.setup.cloudAccountsAdd);
                }}
                type="primary"
              >
                Add Account
              </Button>
            </Tooltip>
          </>
        }
      >
        <CloudAccountTable
          saveDocs={this.saveDocs.bind(this)}
          deleteAccount={this.deleteAccount.bind(this)}
        />
      </PageHeaderWrapper>
    );
  }
}
export default CloudAccountsList;
